import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useUserSWR from '../../hooks/user/useUserSWR';
import {
    Box,
    Card,
    CardContent,
    CardHeader,
    styled,
    Typography,
} from '@mui/material';
import useProfileEditorDialog from '../../hooks/useProfileEditorDialog';
import EditIcon from '@mui/icons-material/Edit';
import usePaymentOptionsSWR from '../../hooks/usePaymentOptions';
import { ProfileLoadingLayout } from '../layouts/LoadingLayouts/ProfileLoadingLayout';
import { ErrorTypography } from '../styled/ErrorTypography';
import useFullScreenLoading from '../../hooks/useFullScreenLoading';

const StyledInfoValue = styled(Box)(() => ({
    fontWeight: 'bold',
}));

export const ProfileContent = () => {
    const { user, isLoading, isError, forceRefresh } = useUserSWR();
    const profileDialog = useProfileEditorDialog();
    const { payments } = usePaymentOptionsSWR();
    const fullScreenLoading = useFullScreenLoading();

    const handleClick = () => {
        if (!isError && !isLoading) {
            // profileDialog.setSelectedUser(user);
            profileDialog.showProfileEditor(true, user);
        }
    };

    useEffect(() => {
        if (profileDialog.profileDialogClosedWithSuccess) {
            fullScreenLoading.setFullScreenLoading(true);
            profileDialog.setProfileDialogClosedWithSuccess(false);
            forceRefresh().finally(() => {
                fullScreenLoading.setFullScreenLoading(false);
            });
        }
    }, [profileDialog.profileDialogClosedWithSuccess]);

    const { t } = useTranslation();

    const getPaymentsName = (userPayment) => {
        return (
            payments &&
            userPayment &&
            payments.find((elem) => elem.code == userPayment)?.description
        );
    };

    return (
        <Box sx={{ paddingBottom: '15px' }}>
            <Card sx={{ maxWidth: 345 }}>
                <CardHeader
                    title={t('PROFILE.PROFILE_CONTENT.TITLE')}
                    action={
                        <EditIcon
                            fontSize={'small'}
                            onClick={handleClick}
                            sx={{ cursor: 'pointer' }}
                        />
                    }
                />
                <CardContent>
                    {isLoading && <ProfileLoadingLayout />}
                    {isError && (
                        <ErrorTypography errorCode={'PROFILE_NOT_LOADED'} />
                    )}
                    {!isLoading && !isError && (
                        <>
                            <Typography>
                                <StyledInfoValue component="span">
                                    {t('PROFILE.PROFILE_CONTENT.NAME')}
                                </StyledInfoValue>
                                : {user.last_name} {user.first_name}
                            </Typography>
                            <Typography>
                                <StyledInfoValue component="span">
                                    {t('PROFILE.PROFILE_CONTENT.EMAIL')}
                                </StyledInfoValue>
                                : {user.email}
                            </Typography>
                            <Typography>
                                <StyledInfoValue component="span">
                                    {t('PROFILE.PROFILE_CONTENT.COMPANY')}
                                </StyledInfoValue>
                                : {user.company}
                            </Typography>
                            <Typography>
                                <StyledInfoValue component="span">
                                    {t('PROFILE.PROFILE_CONTENT.PHONE')}
                                </StyledInfoValue>
                                : {user.phone}
                            </Typography>
                            <Typography>
                                <StyledInfoValue component="span">
                                    {t('PROFILE.PROFILE_CONTENT.TAX_NUMBER')}
                                </StyledInfoValue>
                                : {user.tax_number}
                            </Typography>
                            <Typography>
                                <StyledInfoValue component="span">
                                    {t('PROFILE.PROFILE_CONTENT.DEFAULT_STOCK')}
                                </StyledInfoValue>
                                : {user.default_stock}
                            </Typography>
                            <Typography>
                                <StyledInfoValue component="span">
                                    {t('PROFILE.PROFILE_CONTENT.PAYMENT')}
                                </StyledInfoValue>
                                : {getPaymentsName(user.default_payment_method)}
                            </Typography>
                        </>
                    )}
                </CardContent>
            </Card>
        </Box>
    );
};
